import { questionTypes } from 'sharedParts';
import { get } from 'lodash';

export default block => {
  const type = get(block, 'type');
  return (
    type === questionTypes.nextButton || type === questionTypes.submitButton
  );
};
